import React from 'react'
import cx from 'classnames'
import styles from './index.css'

const Button = ({ className, color = 'blue', onClick, children, ...rest }) => (
  <button
    className={cx(styles.button, styles[`${color}Button`], className)}
    onClick={onClick}
    {...rest}
  >
    {children}
  </button>
)

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js